import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import reportConfigs, { reportCategories } from "./utils/reportConfigs";

const ReportSelector = ({ selectedReport, onSelectReport }) => {
  const { t } = useTranslation("translations");
  const reports = Object.values(reportConfigs);

  return (
    <div className="reports__selector">
      {reportCategories.map((category) => {
        const categoryReports = reports.filter((r) => r.category === category.id);
        if (categoryReports.length === 0) return null;

        return (
          <div key={category.id} className="reports__category">
            <h3 className="reports__category-title">{t(category.labelKey)}</h3>
            <div className="reports__category-grid">
              {categoryReports.map((report) => (
                <div
                  key={report.id}
                  className={`reports__card ${selectedReport?.id === report.id ? "reports__card--active" : ""}`}
                  onClick={() => onSelectReport(report)}
                >
                  <div className="reports__card-icon">
                    <FontAwesomeIcon icon={report.icon} />
                  </div>
                  <div className="reports__card-content">
                    <h4 className="reports__card-title">{t(report.titleKey)}</h4>
                    <p className="reports__card-description">{t(report.descriptionKey)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReportSelector;
